import yup from 'yup'
import { precision } from '@atheneum/api/dist/lib'

export function getValidationSchema (staticData, isCreditNote) {
  const { INVOICE_TYPES } = staticData.CONST

  const commentSchema = isCreditNote
    ? yup.string().required('Reason for credit note is a required field')
    : yup.string().nullable()

  return yup.object().shape({
    invoiceTypeId: yup.number().required(),
    invoicingEntity: yup
      .object()
      .shape({
        id: yup
          .number()
          .typeError('Invoicing entity is required')
          .required('Invoicing entity is required')
      })
      .typeError('Invoicing entity is required'),
    vat: yup
      .number()
      .min(0, 'VAT must be a number between 0 and 100.')
      .max(100, 'VAT must be a number between 0 and 100.')
      .typeError('VAT is required')
      .required('VAT is required')
      .test(
        'six-decimal-places',
        'Number can contain up to 6 decimal places. (e.g. 33.123456)',
        precision(6)
      ),
    atheneumOffice: yup
      .object()
      .shape({
        id: yup
          .number()
          .typeError('Atheneum office is required')
          .required('Atheneum office is required')
      })
      .typeError('Atheneum office is required'),
    currency: yup
      .object()
      .shape({
        id: yup
          .number()
          .typeError('Currency is required')
          .required('Invoicing entity is required')
      })
      .typeError('Currency is required'),
    caseCode: yup.string().nullable(),
    startDate: yup.date().when('invoiceTypeId', {
      is: INVOICE_TYPES.NON_PAYG,
      then: yup
        .date()
        .required('Start date is required')
        .typeError('Start date is required'),
      otherwise: yup.date().nullable()
    }),
    endDate: yup.date().when('invoiceTypeId', {
      is: INVOICE_TYPES.NON_PAYG,
      then: yup
        .date()
        .required('End date is required')
        .typeError('End date is required'),
      otherwise: yup.date().nullable()
    }),
    comment: commentSchema,
    isWriteOff: yup.bool().default(false),
    hideExpertName: yup.bool().default(true)
  })
}
